<template>
  <div className='core'>
    <div className='layui-fluid'>
      <div className="Echarts statistics-charts-style">
        <div id="main" style="width: 600px;height: 400px;"></div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../../utils/map/css/core.css"
import * as echarts from 'echarts';

export default {
  name: 'lineStatistics',
  data() {
    return {
      dataList: []
    }
  },
  props: {
    lineData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  mounted() {
    this.dataList = this.lineData;
    this.myEcharts();
  },
  watch: {
    lineData(value) {
      this.dataList = value
      this.myEcharts()
    },
  },
  methods: {
    myEcharts() {
      let myChart = echarts.init(document.getElementById('main'));

      let option = {
        tooltip: {},
        title: {
          text: "故障每月变化趋势",
          // subtext: "数起科技",
          left: "center",
          // top: "center",
          textStyle: {
            // fontSize: 30
          },
        },
        legend: {},
        grid: {
          // containLabel: true,
          containLabel: false,
        },
        xAxis: {
          name: '月份',
          type: 'category',
          data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
        },
        yAxis: {
          name: '个数',
          type: 'value'
        },
        toolbox: {
          feature: {
            dataView: {readOnly: false},
            magicType: {type: ['line', 'bar']},
            saveAsImage: {},
          }
        },
        series: [
          {
            data: this.dataList,
            type: 'line',
            itemStyle: {
              normal: {
                color: '#5470c6'
              }
            },
          }
        ]
      };
      myChart.setOption(option);
    },

  }
}
</script>

<style scoped>
.statistics-charts-style {
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/repairs/repairStatistics/lineStatistics.vue